// 💾 src/components/home/CTASection.tsx
// src/components/home/CTASection.tsx
import React from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import "./style/CTASection.scss"

const CTASection: React.FC = () => {
  const { t } = useTranslation()
  const { lng = "en" } = useParams<{ lng: string }>()
  const navigate = useNavigate()

  // helper to prefix routes with current language
  const withLang = (path: string) => `/${lng}${path}`

  return (
    <section className="cta-section">
      <h2>{t("home.ctaSection.title")}</h2>
      <p>{t("home.ctaSection.text")}</p>
      <button onClick={() => navigate(withLang("/register"))}>
        {t("home.ctaSection.button")}
      </button>
    </section>
  )
}

export default CTASection
